import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d04fbbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-10 px-12 pt-0" }
const _hoisted_2 = { class: "flex justify-left font-bold border-solid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", null, "Back", -1))
const _hoisted_4 = { class: "p-5 pb-0 sm:p-5 text-medium sm:text-xl font-bold" }
const _hoisted_5 = { class: "py-5 sm:px-20 sm:flex sm:flex-row items-center justify-center" }
const _hoisted_6 = { class: "image-style cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Price", -1))
const _hoisted_8 = { class: "pb-5" }
const _hoisted_9 = { class: "text-xl font-bold" }
const _hoisted_10 = { class: "pb-5 px-0 sm:px-32 items-center justify-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Description", -1))
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ClipLoader = _resolveComponent("ClipLoader")!
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_carousel = _resolveComponent("carousel")!
  const _component_ContactMe = _resolveComponent("ContactMe")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", {
        class: "cursor-pointer hover:text-red-600",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToHomePage && _ctx.backToHomePage(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'chevron-left'],
          class: "pr-2"
        }),
        _hoisted_3
      ])
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.bikeTitle), 1),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_carousel, {
        class: "w-full sm:w-7/12",
        "items-to-show": 1
      }, {
        addons: _withCtx(() => [
          _createVNode(_component_navigation),
          _createVNode(_component_pagination)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bike.images, (image, index) => {
            return (_openBlock(), _createBlock(_component_slide, {
              key: index,
              onClick: ($event: any) => (_ctx.toggleZoom(index))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ClipLoader, {
                  class: "absolute -z-10 p-5",
                  color: _ctx.colorLoading
                }, null, 8, ["color"]),
                _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                  [_directive_lazy, image]
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("label", _hoisted_9, "€" + _toDisplayString(_ctx.bike.price), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("p", {
          class: "pb-5 text-center",
          innerHTML: _ctx.formattedDescription
        }, null, 8, _hoisted_12)
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleZoom(-1)))
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: _ctx.bike.images[_ctx.zoomedIndex],
              class: "zoomed-image cursor-pointer"
            }, null, 8, _hoisted_14)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ContactMe)
  ]))
}